import { ReactNode } from "react";

type Props = {
  description: string;
  icon: (props: { className?: string }) => JSX.Element;
  children: ReactNode;
};

export default function ImprovementInfoWrapper({
  description,
  icon: IconComponent,
  children,
}: Props) {
  return (
    <div>
      <div className="flex items-center bg-dark-800/50 rounded-2xl overflow-hidden">
        <div className="shrink-0 size-25 p-6.5 bg-gradient-to-br from-accent-solid/30 to-transparent">
          <IconComponent className="size-full" />
        </div>
        <p className="py-2 px-5 text-15">{description}</p>
      </div>
      {children}
    </div>
  );
}
